import "./SignInAction.scss";
import React, { useState, useEffect } from "react";
import {
  IonList,
  IonItem,
  IonLabel,
  IonBadge,
  IonLoading,
  // IonInfiniteScroll,
  // IonInfiniteScrollContent,
} from "@ionic/react";
import moment from "moment";
import { getRequestHistoryByIdentity } from "../../api/requestHistory";
import { useTracked } from "../../state";

interface Props {
  tabValue: any;
}

const SignInAction: React.FC<Props> = ({ tabValue }) => {
  const [state] = useTracked();
  const { identity } = state;
  const [lastActions, setLastActions] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  // const [isInfiniteDisabled, setInfiniteDisabled] = useState(false);
  // const pageSize = 20;
  const filter = { status: "NOT_PENDING" };
  // const limit = 20;

  React.useEffect(() => {
    if (state.authorization && state.identity && state.token) {
      fetchData(identity);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.authorization, state.identity, state.token]);

  React.useEffect(() => {
    if (state.authorizationActionTimestamp) {
      fetchData(identity);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.authorizationActionTimestamp]);

  useEffect(() => {
    if (identity && tabValue === "actioned") {
      fetchData(identity);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabValue]);

  const fetchData = async (identity: string) => {
    try {
      setIsLoading(true);
      const requestsHistory: any = await getRequestHistoryByIdentity(
        identity,
        filter,
        // limit,
        // pageSize
      );
      if (requestsHistory?.status === 200) {
        const { data = [] } = requestsHistory;
        const filteredData = data.filter((val: any) => {
          return val.type === "sign_in";
        });
        setLastActions(filteredData);
      }

      setIsLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  // const loadData = async (ev: any) => {
  //   try {
  //     const requestsHistory: any = await getRequestHistoryByIdentity(
  //       identity,
  //       filter,
  //       // limit,
  //       // pageSize
  //     );

  //     if (requestsHistory?.status === 200) {
  //       const { data = [], totalCount, pageSize } = requestsHistory;
  //       const max = data.length + pageSize;
  //       const min = max - pageSize;
  //       const newData = [];
  //       for (let i = min; i < data.length; i++) {
  //         newData.push(data[i]);
  //       }

  //       setLastActions([...data, ...newData]);
  //       if (data.length === totalCount) {
  //         setInfiniteDisabled(true);
  //       }
  //       ev.target.complete();
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  const getActionTitle = (val: any) => {
    // temporary: need to map out ACTION from api.
    if (val.requestAction?.includes("api-key")) {
      return "Action";
    } else {
      return "Sign In";
    }
  };

  return (
    <React.Fragment>
      <IonList className="sign-in-action-list">
        {isLoading && <IonLoading isOpen={isLoading} />}
        {lastActions.map((val: any, index: number) => {
          return (
            <IonItem key={index} lines="full">
              <IonLabel>
                {getActionTitle(val)} - {val?.appId === "1" && "Verifier"}
                {val?.appId === "2" && "Messenger"}
                {val?.appId === "3" && "Exchange"}
                {val?.appId === "4" && "Sign Abaxx"}
                {val?.appId === "5" && "Clearing"}
                <div className="list-subtitle">
                  <h6>
                    Authorized{" "}
                    {moment.unix(val.createdAt).format("DD MMM YYYY, hh:mm")}
                  </h6>
                </div>
              </IonLabel>
              <IonLabel slot="end">
                <div className="list-subtitle-second">
                  {val?.status === "AUTHORIZED" && (
                    <IonBadge className="authorized-bagde">Authorized</IonBadge>
                  )}
                  {val?.status === "DENIED" && (
                    <IonBadge className="denied-bagde">Denied</IonBadge>
                  )}

                  {val?.status === "UNAUTHORIZED" &&(
                    <IonBadge className="unauthorized-bagde">Unauthorized</IonBadge>
                  )}
                </div>
              </IonLabel>
            </IonItem>
          );
        })}
      </IonList>
      {/* <IonInfiniteScroll
        onIonInfinite={loadData}
        threshold="100px"
        disabled={isInfiniteDisabled}
      >
        <IonInfiniteScrollContent
          loadingSpinner="bubbles"
          loadingText="Loading more data..."
        ></IonInfiniteScrollContent>
      </IonInfiniteScroll> */}
    </React.Fragment>
  );
};

export default SignInAction;
